import { getNodeEntries } from '@udecode/plate';

export const getMergedCells = (editor, at) => {
  const entries = getNodeEntries(editor, { at });
  const mergedCells = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const entry of entries) {
    const [node] = entry;
    if (node && node.colSpan) {
      mergedCells.push(entry);
    }
  }

  return mergedCells;
};
